module.exports = __webpack_public_path__ + "img/team.0a049b91.jpg";